import types from './mutation-types'
import AssessmentConfigs from '@/services/AssessmentConfigs'
import { allSettled } from '@/core/helpers/promise.helpers'

/**
 *  Boot AssessmentConfigs
 *
 * @param dispatch
 * @param rootGetters
 *
 * @returns {Promise<any>}
 */
export const boot = ({ dispatch, rootGetters }) => {
  const boot = rootGetters['auth/entitlements'].getAnyPassed({
    'fetchAssessmentConfigs': { task: 'read', task_type: 'read' }
  }).map(action => dispatch(action)).map(allSettled)

  return Promise.all(boot)
}

/**
 * Fetch assessment config
 *
 * @param commit
 */
export const fetchAssessmentConfigs = ({ commit }) => {
  return AssessmentConfigs.fetchAssessmentConfigs()
    .then((assessmentConfigs) => {
      commit(types.ADD_ASSESSMENT_CONFIGS, { assessmentConfigs, clearExisting: true })
      return assessmentConfigs
    })
}

/**
 * Create assessment config
 *
 * @param commit
 */
export const createAssessmentConfig = ({ commit }, payload) => {
  return AssessmentConfigs.createAssessmentConfig(payload)
    .then((assessmentConfig) => {
      commit(types.ADD_ASSESSMENT_CONFIGS, { assessmentConfigs: [assessmentConfig], clearExisting: false })
      return assessmentConfig
    })
}

/**
 * Update assessment config
 *
 * @param commit
 */
export const updateAssessmentConfig = ({ commit }, { id, ...payload }) => {
  return AssessmentConfigs.updateAssessmentConfig(id, payload)
    .then((assessmentConfig) => {
      commit(types.ADD_ASSESSMENT_CONFIGS, { assessmentConfigs: [assessmentConfig], clearExisting: false })
      return assessmentConfig
    })
}

/**
 * Update assessment config
 *
 * @param commit
 */
export const deleteAssessmentConfig = ({ commit }, { id }) => {
  return AssessmentConfigs.deleteAssessmentConfig(id)
    .then((assessmentConfig) => {
      commit(types.REMOVE_ASSESSMENT_CONFIGS, { id: id })
      return assessmentConfig
    })
}

/**
 * Reset stored data
 *
 * @param commit
 */
export const clear = ({ commit }) => {
  commit(types.CLEAR)
}

export default {
  boot,
  fetchAssessmentConfigs,
  createAssessmentConfig,
  updateAssessmentConfig,
  deleteAssessmentConfig,
  clear
}
